import { ExclamationIcon } from '@heroicons/react/solid';
import { Link } from 'react-router-dom';

const NotfoundComp = () => {
  return (
    <div className="flex h-screen">
      <div className="m-auto drop-shadow-lg">
        <div className="text-red-500">
          <ExclamationIcon />
        </div>
        <h1 className="text-3xl text-red-500 mb-3 drop-shadow-xl">
          PAGE NOT FOUND
        </h1>
        <Link to="/" className="px-3 py-1 bg-amber-400 rounded-md">
          Go Back
        </Link>
      </div>
    </div>
  );
};

export default NotfoundComp;
